import { BubbleAlert } from '@go-client/components/BubbleUI';
import { useBubbleDrawerTools } from '@go-client/components/BubbleUI/BubbleDrawer';
import {
  BubbleFormActions,
  BubbleFormFooter,
  BubbleFormHeader,
  FormPageComponentHelpfulProps,
} from '@go-client/components/BubbleUI/BubbleForm';
import { FormGenericContainer } from '@go-client/components/FormGenericContainer';
import {
  EventTemplateFormikForm,
  EventTemplateFormikTicketsSubTab,
} from '@go-client/components/Formik/EventTemplateFormik';
import { RESERVABLE_EXPERIENCE_TYPE } from '@go-shared/types/reservable';
import { FormikProps } from 'formik';
import React from 'react';
import { RESERVABLE_SCHEDULE_BREADCRUMBS } from '../ReservableSchedulePath';

interface EnterTicketsPagePropsBase {
  isBusy: boolean;
  setIsBusy: (isBusy: boolean) => void;
  libraryLocked: boolean;
  eventFormik: FormikProps<EventTemplateFormikForm>;
  experienceType: RESERVABLE_EXPERIENCE_TYPE;
  expTypeLabel: string;
}

type EnterTicketsPageProps = EnterTicketsPagePropsBase &
  FormPageComponentHelpfulProps<RESERVABLE_SCHEDULE_BREADCRUMBS>;

export default function EnterTicketsPage(props: EnterTicketsPageProps) {
  const forwardDisabled =
    (props.eventFormik.errors.reservableTickets ?? []).length > 0 ||
    props.eventFormik.values.reservableTickets.length < 1;

  const { scrollToBottom } = useBubbleDrawerTools();

  return (
    <div className="eaf-1">
      <FormGenericContainer
        className="h-screen flex flex-col"
        bodyClassName="flex-grow flex flex-col"
        footer={() => (
          <>
            <BubbleFormFooter
              className="text-slate-dark mr-auto"
              items={[{ label: 'Experience Selected', value: props.eventFormik.values.title }]}
            />
            <BubbleFormActions
              isBusy={props.isBusy}
              forwardTitle={props.forwardTitle || 'Next: Packages'}
              backTitle={props.backTitle}
              onGoForward={props.onGoForward}
              onGoBack={props.onGoBack}
              forwardDisabled={forwardDisabled}
            />
          </>
        )}
      >
        <BubbleFormHeader<RESERVABLE_SCHEDULE_BREADCRUMBS>
          title={props.title || 'Create Experience'}
          subtitle={props.subtitle || `Add ${props.expTypeLabel}s`}
          pageIndex={props.pageIndex ?? 1}
          onClose={props.onClose}
          activeBreadcrumb="tickets"
          breadcrumbs={props.breadcrumbs}
          onBreadcrumbClick={props.onBreadcrumbClick}
        />
        {props.libraryLocked && (
          <BubbleAlert className="mb-3" variant="ocean">
            <span className="font-semibold">This template cannot be modified.</span> It may be a
            brand level event or you lack library permissions.
          </BubbleAlert>
        )}
        <EventTemplateFormikTicketsSubTab
          formik={props.eventFormik}
          type="create"
          experienceType={props.experienceType}
          readOnly={props.libraryLocked}
          onAddNewTickets={scrollToBottom}
        />
      </FormGenericContainer>
    </div>
  );
}
